var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dsfa-sc-schedule"},[_c('DsfSCPanel',{attrs:{"title":"日程安排","more":true,"setting":true}},[_c('dsf-virtual-scroll',{attrs:{"scroll-Y":""}},[_c('DsfTeasUniteScheduleList',{attrs:{"dataList":_vm.dataList}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }